// ============================================
// SHOPIFY FILTER SCRIPT - COLLECTION-BASED
// Product Type dan Category adalah collection terpisah (saling exclude)
// ============================================

// console.log('🔧 Filter script loading (Collection-based version)...');

document.addEventListener('DOMContentLoaded', function() {
  // console.log('✅ DOM Content Loaded');
  
  const CONFIG = {
    mobileFilters: [
      { id: 'type', label: 'Type', title: 'Product Type', isCollection: true },
      { id: 'category', label: 'Category', title: 'Category', isCollection: true }
    ]
  };

  const state = {
    currentCollection: null,
    currentCollectionType: null, // 'type', 'category', or null
    pendingCollection: null,
    isModalOpen: false,
    activeModalFilterId: null
  };

  function getCollectionData() {
    const dataEl = document.getElementById('collection-data');
    if (dataEl) {
      try {
        return JSON.parse(dataEl.textContent);
      } catch (e) {
        console.error('Error parsing collection data:', e);
      }
    }
    return { 
      currentCollection: 'products',
      allTypes: [],
      allCategories: []
    };
  }

  function determineCollectionType(collectionHandle) {
    const data = getCollectionData();
    
    if (collectionHandle === 'products') {
      return null; // All products
    }
    
    if (data.allTypes.includes(collectionHandle)) {
      return 'type';
    }
    
    if (data.allCategories.includes(collectionHandle)) {
      return 'category';
    }
    
    return null;
  }

  function loadCurrentCollection() {
    const data = getCollectionData();
    state.currentCollection = data.currentCollection;
    state.currentCollectionType = determineCollectionType(data.currentCollection);
    
    // console.log('📍 Current collection:', state.currentCollection, 'Type:', state.currentCollectionType);
  }

  function openFilterModal(filterId = null) {
    // console.log('🔓 Opening modal for:', filterId || 'All Filters');
    
    if (!elements.modalElement || !elements.modalBody) return;
    
    loadCurrentCollection();
    state.isModalOpen = true;
    state.activeModalFilterId = filterId;
    
    // Set modal title dynamically
    if (elements.modalTitle) {
      if (filterId) {
        const filterConfig = CONFIG.mobileFilters.find(f => f.id === filterId);
        elements.modalTitle.textContent = filterConfig ? filterConfig.title : 'Filter';
      } else {
        elements.modalTitle.textContent = 'All Filters';
      }
    }
    
    renderModalContent();
    
    elements.modalBackground?.classList.add('show');
    elements.modalElement.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  function renderModalContent() {
    if (!elements.modalBody) return;
    
    let filtersHTML = '';
    
    const filtersToRender = state.activeModalFilterId 
      ? CONFIG.mobileFilters.filter(f => f.id === state.activeModalFilterId)
      : CONFIG.mobileFilters;

    filtersToRender.forEach(filter => {
      const options = getFilterOptions(filter.id);
      
      if (options.length > 0) {
        // Render as radio buttons (single select)
        const optionsHTML = options.map((opt, idx) => {
          const isActive = state.currentCollection === opt.value;
          
          return `
            <label for="mobile-${filter.id}-${idx}" class="label-input-filter-product ${isActive ? 'label-input-filter-product-active active' : ''}" >
              <input
                type="radio"
                name="mobile-${filter.id}"
                style="display: none;"
                id="mobile-${filter.id}-${idx}"
                value="${opt.value}"
                data-filter-id="${filter.id}"
                ${isActive ? 'checked' : ''}
              >
              <span class="visual-display__child"></span>
              ${opt.label}
            </label>
          `;
        }).join('');
        
        // Add "All" option for categories
        let allOptionHTML = '';
        if (filter.id === 'category') {
          const isAllActive = state.currentCollection === 'products' || state.currentCollectionType !== 'category';
          allOptionHTML = `
            <label for="mobile-${filter.id}-all" class="label-input-filter-product ${isAllActive ? 'label-input-filter-product-active active' : ''}">
              <input
                type="radio"
                name="mobile-${filter.id}"
                id="mobile-${filter.id}-all"
                value="products"
                data-filter-id="${filter.id}"
                style="display: none;"
                ${isAllActive ? 'checked' : ''}
              >
              <span class="visual-display__child"></span>
              All Categories
            </label>
          `;
        }
        
        filtersHTML += `
          <div class="modal-filter-section">
            <div class="modal-filter-header">
              <h4>${filter.title}</h4>
              <span class="filter-count-badge">${state.currentCollectionType === filter.id ? '1 selected' : 'All'}</span>
            </div>
            <div class="modal-checkbox-group">
              ${allOptionHTML}
              ${optionsHTML}
            </div>
          </div>
        `;
      }
    });

    elements.modalBody.innerHTML = `
      <div class="modal-all-filters">
        ${filtersHTML}
      </div>
    `;
    
    setupAllFiltersEventListeners();
  }

  const elements = {
    dynamicFilter: document.getElementById('dynamicFilter'),
    scrollBox: document.getElementById('scrollBox'),
    modalBackground: document.getElementById('modalBackground'),
    modalElement: document.getElementById('modalElement'),
    modalTitle: document.getElementById('modalTitle'),
    modalBody: document.getElementById('modalBody'),
    modalClose: document.getElementById('modalClose')
  };

  // console.log('📊 Elements found:', {
  //   dynamicFilter: !!elements.dynamicFilter,
  //   scrollBox: !!elements.scrollBox,
  //   modal: !!elements.modalElement
  // });

  function getFilterOptions(filterId) {
    const data = getCollectionData();
    
    if (filterId === 'type') {
      // Get type options from desktop filter
      const typeLinks = document.querySelectorAll('[data-filter-type="type"] .filter-list a');
      const types = [];
      
      typeLinks.forEach(link => {
        const href = link.getAttribute('href');
        const label = link.textContent.trim();
        
        if (href) {
          const match = href.match(/\/collections\/([^\/\?]+)/);
          if (match) {
            types.push({
              label: label,
              value: match[1]
            });
          }
        }
      });
      
      return types;
    }
    
    if (filterId === 'category') {
      // Get category options from desktop filter
      const categoryLinks = document.querySelectorAll('[data-filter-type="category"] .filter-list a');
      const categories = [];
      
      categoryLinks.forEach(link => {
        const href = link.getAttribute('href');
        const label = link.textContent.trim();
        
        if (href && !href.includes('/products') && label !== 'All Category') {
          const match = href.match(/\/collections\/([^\/\?]+)/);
          if (match) {
            categories.push({
              label: label,
              value: match[1]
            });
          }
        }
      });
      
      return categories;
    }
    
    return [];
  }

  function renderMobileFilterButtons() {
    if (!elements.scrollBox) return;
    
    const buttons = [];
    
    // Show current active collection as badge
    if (state.currentCollectionType === 'type') {
      const typeOption = getFilterOptions('type').find(opt => opt.value === state.currentCollection);
      if (typeOption) {
        buttons.push({
          id: 'type',
          label: typeOption.label,
          value: state.currentCollection
        });
      }
    } else if (state.currentCollectionType === 'category') {
      const categoryOption = getFilterOptions('category').find(opt => opt.value === state.currentCollection);
      if (categoryOption) {
        buttons.push({
          id: 'category',
          label: categoryOption.label,
          value: state.currentCollection
        });
      }
    }
    
    const buttonsHTML = buttons.map(btn => `
      <div class="filter-btn-product filter-btn-active" data-filter-id="${btn.id}" data-value="${btn.value}">
        ${btn.label}
        <span onclick="clearFilter()" style="margin-left: 4px; cursor: pointer;">×</span>
      </div>
    `).join('');
    
    elements.scrollBox.innerHTML = buttonsHTML;
  }

  window.clearFilter = function() {
    // console.log('🗑️ Clearing filter, going to All Products');
    window.location.href = 'https://buytcm.com/collections/products';
  };

  function initDesktopFilters() {
    const desktopFilters = document.querySelectorAll('.desktop-filter-wrapper .item-filter');
    
    desktopFilters.forEach(filter => {
      const header = filter.querySelector('.product-filter-header');
      header?.addEventListener('click', () => {
        filter.classList.toggle('open');
      });
    });
    
    // console.log('✅ Desktop filters initialized');
  }

  function setupAllFiltersEventListeners() {
    const inputs = elements.modalBody?.querySelectorAll('input[type="radio"]');
    
    inputs?.forEach(input => {
      input.addEventListener('change', function(e) {
        const filterId = e.target.dataset.filterId;
        const collectionHandle = e.target.value;
        
        // console.log(`🚀 Collection changed: ${filterId} → ${collectionHandle}`);
        
        // Navigate immediately
        window.location.href = `/collections/${collectionHandle}`;
      });
    });
  }

  function updateDynamicFilterBadge() {
    const filterTextEl = document.getElementById('filterText');
    
    if (!filterTextEl) return;
    
    const existingBadge = filterTextEl.querySelector('.filter-badge');
    if (existingBadge) existingBadge.remove();
    
    // Show badge only if a specific collection is active (not 'products')
    if (state.currentCollectionType) {
      const badge = document.createElement('span');
      badge.className = 'filter-badge';
      badge.textContent = '1';
      filterTextEl.appendChild(badge);
    }
  }

  function closeModal() {
    // console.log('🔒 Closing modal');
    state.isModalOpen = false;
    state.activeModalFilterId = null;
    elements.modalBackground?.classList.remove('show');
    elements.modalElement?.classList.remove('show');
    document.body.style.overflow = '';
  }

  function init() {
    // console.log('🚀 Initializing collection-based filters...');
    
    loadCurrentCollection();
    initDesktopFilters();
    updateDynamicFilterBadge();
    renderMobileFilterButtons();
    
    elements.dynamicFilter?.addEventListener('click', () => {
      // console.log('🖱️ Dynamic filter clicked - opening ALL filters');
      openFilterModal(null);
    });
    
    elements.modalClose?.addEventListener('click', closeModal);
    elements.modalBackground?.addEventListener('click', closeModal);
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && state.isModalOpen) closeModal();
    });
    
    // console.log('✅ Filter initialization complete!');
    // console.log('📋 Current state:', {
    //   collection: state.currentCollection,
    //   type: state.currentCollectionType
    // });
  }

  init();
});